import { useEffect, useState } from 'react';
import agentStatusWebSocketService from '../services/agentStatusWebSocket';

const getOnline = () => (typeof navigator === 'undefined' ? true : navigator.onLine !== false);

/**
 * Combines the browser's network state with the SignalR connection state.
 * `isStale` is true whenever live agent data can't be trusted to be current.
 */
const useConnectionStatus = () => {
	const [isOnline, setIsOnline] = useState(getOnline);
	const [socketStatus, setSocketStatus] = useState(() => agentStatusWebSocketService.getConnectionStatus());

	useEffect(() => {
		const goOnline = () => setIsOnline(true);
		const goOffline = () => setIsOnline(false);
		window.addEventListener('online', goOnline);
		window.addEventListener('offline', goOffline);
		const unsubscribe = agentStatusWebSocketService.onConnectionStatusChange(setSocketStatus);
		// Catch anything that changed between first render and subscription
		setSocketStatus(agentStatusWebSocketService.getConnectionStatus());
		setIsOnline(getOnline());
		return () => {
			window.removeEventListener('online', goOnline);
			window.removeEventListener('offline', goOffline);
			unsubscribe();
		};
	}, []);

	const isReconnecting = socketStatus === 'reconnecting' || socketStatus === 'disconnected';

	return { isOnline, socketStatus, isReconnecting, isStale: !isOnline || isReconnecting };
};

export default useConnectionStatus;
